import React from 'react';
import './AdminEmptyState.css';

interface AdminEmptyStateProps {
  title?: string;
  subtitle?: string;
  hint?: string;
}

const AdminEmptyState: React.FC<AdminEmptyStateProps> = ({
  title = 'CHOOSE A LOCATION',
  subtitle = 'to begin configuring',
  hint = 'Select a store from the dropdown above'
}) => {
  return (
    <div className="admin-empty-state">
      <div className="admin-empty-content">
        <div className="admin-empty-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        </div>
        <h1 className="admin-empty-title">{title}</h1>
        <p className="admin-empty-subtitle">{subtitle}</p>
        {hint && (
          <p className="admin-empty-hint">
            <span className="hint-arrow">↑</span> {hint}
          </p>
        )}
      </div>
    </div>
  );
};

export default AdminEmptyState;
